// src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHealth, startStory } from '../services/api';
import StoryCustomizer from '../components/StoryCustomizer';

function Home() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getHealth().then(setHealth).catch(console.error);
  }, []);

  const handleStartStory = async (formData) => {
    setLoading(true);
    try {
      const response = await startStory(formData);
      navigate(`/story/${response.data.sesion.id}`);
    } catch (error) {
      console.error('Error:', error);
      alert('Error al crear el universo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="hero-section">
        <h1 className="hero-title">KREAMUN</h1>
        <p className="hero-subtitle">
          "En alg&uacute;n lugar del multiverso, un mundo espera ser creado... por ti."
        </p>
        
        {health && (
          <div className="status-badge">
            <span className="status-dot"></span>
            <span>Multiverso conectado</span>
          </div>
        )}
      </div>

      <div className="customizer-wrapper">
        <StoryCustomizer onStart={handleStartStory} loading={loading} />
      </div>
    </div>
  );
}

export default Home;